import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {DirectiveOptions} from 'vue/types/options';

gsap.registerPlugin(ScrollTrigger);

const enterFade: DirectiveOptions = {
    inserted: (el, binding) => {
        const triggerSelector = el.dataset.triggerSelector || '.container';
        let trigger: HTMLElement;
        if (triggerSelector === 'self') {
            trigger = el;
        } else {
            trigger = el.closest(triggerSelector) || el;
        }

        gsap.from(
            el,
            {
                bottom: '100%',
                scrollTrigger: {
                    trigger,
                    start: 'top 90%',
                    end: 'top 40%',
                    scrub: 0.5,
                    markers: false,
                },
            },
        );
    },
};
export default enterFade;
